export const normalizeTeamMemberGender = value => String(value || "female").toLowerCase() === "male" ? "male" : "female";

export const getTeamMemberName = member => `${member?.firstName || ""} ${member?.lastName || ""}`.trim() || member?.name || "Team Member";

const getInitials = name => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "TM";
  return parts.slice(0, 2).map(part => part[0]?.toUpperCase() || "").join("") || "TM";
};

const isExternalUrl = value => /^https?:\/\//i.test(String(value || "").trim());

const isAllowedLocalAvatarSource = value => {
  const src = String(value || "").trim();
  if (!src) return false;
  if (isExternalUrl(src)) return false;
  return (
    src.startsWith("data:image/") ||
    src.startsWith("blob:") ||
    src.startsWith("/") ||
    src.startsWith("./") ||
    src.startsWith("../")
  );
};

export const createInlineFallbackAvatar = ({ name, gender }) => {
  const normalizedGender = normalizeTeamMemberGender(gender);
  const initials = getInitials(name);
  const palette = normalizedGender === "male"
    ? { start: "#6e8dfc", end: "#334da0" }
    : { start: "#f48bbb", end: "#b05586" };
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" role="img" aria-label="${name}">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${palette.start}" />
          <stop offset="100%" stop-color="${palette.end}" />
        </linearGradient>
      </defs>
      <rect width="120" height="120" rx="60" fill="url(#bg)" />
      <text x="60" y="69" text-anchor="middle" font-family="Arial, sans-serif" font-size="34" font-weight="700" fill="#ffffff">${initials}</text>
    </svg>
  `;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export const createFallbackTeamMemberAvatar = ({ name, gender }) => {
  return createInlineFallbackAvatar({ name, gender });
};

export const getTeamMemberAvatar = member => {
  if (isAllowedLocalAvatarSource(member?.avatarUrl)) return member.avatarUrl;
  return createFallbackTeamMemberAvatar({
    name: getTeamMemberName(member),
    gender: member?.gender
  });
};